import React, { useState, useEffect, useCallback } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ContentTitle } from '../ui/styled';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import { renderCellExpand } from '../common/GridCell/GridCellExpand';
import { Auth } from 'aws-amplify';
import { ACTIVITIES_LIST_URL} from '../../constants';
import {
  EPISODE_2284_REFERENCE_DATA_URL,
  EPISODE_AUTHORIZATION_REFERENCE_DATA_URL,
  EPISODE_CMP_REFERENCE_DATA_URL,
  paginationSize,
  PARTICIPANTS_EPISODE_DETAIL_URL,
} from '../../constants';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import CommonSearch from '../common/Search/CommonSearch';
import { getActivityList } from './services/activitiesApi';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { participant } from '../../redux/participant/participantSlice';
import { getAuthReferenceData } from '../../redux/episode/authTab/authReferenceSlice';
//import { getEpisodeList } from './services/episodesApi';
import { get2284ReferenceData } from '../../redux/episode/2284Tab/2284Reference/2284ReferenceSlice';
import { getCmpReferenceData } from '../../redux/episode/cmpTab/cmpReference/cmpReferenceSlice';
import { singleEpisode } from '../../redux/episode/episodeSlice';
import {
  episodeParticipant,
} from '../../redux/episode/episodeParticipant/episodeParticipantSlice';

const ActivityList = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchActivityList, setSearchActivityList] = useState('');
  const [user, setUser] = useState(null);
  const [activityList, setActivityList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
    sortModel: '',
    filterModel: {} 
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    activityList.pageSize,
    activityList.page,
    activityList.sortModel,
    activityList.filterModel,
    searchActivityList,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const QuickSearchToolbar = () => {
    return (
      <Box pt={1} sx={{ flexGrow: 1, backgroundColor: '#747070' }}>
        <Grid container spacing={1}>
          <Grid item xs={11}>
            <CommonSearch
              searchText={searchActivityList}
              setSearchText={setSearchActivityList}
            />
          </Grid>
          <Grid item xs={1}>  
            <GridToolbarContainer>
              <GridToolbarExport />
            </GridToolbarContainer>
          </Grid>
        </Grid>    
      </Box>  
    );
  };

  const fetchData = async () => {
    setActivityList((old) => ({ ...old, isLoading: true }));
    const commonParams = commonQueryParams(
      ACTIVITIES_LIST_URL,
      searchActivityList,
      activityList
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const activities = await getActivityList({
      commonParams,
      authorization,
    });
    setActivityList((old) => ({
      ...old,
      ...activities,
    }));
  };

  const handleSortModelChange = useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    setActivityList((old) => ({ ...old, sortModel: [...sortModel] }));
  }, []);

  const handleFilterChange = useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    //console.log(filterModel);
    setActivityList((old) => ({ ...old, filterModel: {...filterModel} }));
  }, []);

  const cdcClick = (rowData) => {
    //console.log(rowData);
    const participantDetail = [
      {
        key: rowData.key,
        id: rowData.participantID,
        lastName: rowData.lastName,
        firstName: rowData.firstName,
        middleName: rowData.middle,
        ssn: rowData.SSN,
        suffix: rowData.suffix,
        gender: rowData.gender,
        ethnicityOrRace: rowData.ethnicityOrRace,
        veteran: rowData.veteran,
        deployedCombatDuty: rowData.deployedCombatDuty,
        diagnosedPostTraumaticStressDisorder:
          rowData.diagnosedPostTraumaticStressDisorder,
        arsonist: rowData.arsonist,
        dateOfBirth: rowData.dateOfBirth,
        registration290: rowData.registration290,
        inactive: rowData.inactive,
      },
    ];
    dispatch(participant(participantDetail));
    navigate(`/participants/details/${rowData.participantID}`);
  };

  const episodeClick = (rowData) => {
    console.log('### CLICK FROM ACTIVITY');
    console.log(rowData)

    const episode = [
      {
        episodeId: rowData.episode.episodeID,
        cdc: rowData.episode.CDC
      },
    ];
    const authReferenceUrl = `${EPISODE_AUTHORIZATION_REFERENCE_DATA_URL}/${rowData.id}/referencedata`;
    const reference2284Url = `${EPISODE_2284_REFERENCE_DATA_URL}/${rowData.id}`;
    const cmpReferenceUrl = `${EPISODE_CMP_REFERENCE_DATA_URL}/${rowData.id}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getAuthReferenceData({ authReferenceUrl, authorization }));
    dispatch(get2284ReferenceData({ reference2284Url, authorization }));
    dispatch(getCmpReferenceData({ cmpReferenceUrl, authorization }));
    dispatch(singleEpisode(episode));
    
    //console.log(rowData);
    const participantDetail = [
      {
        key: rowData.episode.partcipant.key,
        id: rowData.episode.partcipant.participantID,
        lastName: rowData.episode.partcipant.lastName,
        firstName: rowData.episode.partcipant.firstName,
        middleName: rowData.episode.partcipant.middleName,
        ssn: rowData.episode.partcipant.SSN,
        suffix: rowData.episode.partcipant.suffix,
        gender: rowData.episode.partcipant.gender,
        ethnicityOrRace: rowData.episode.partcipant.ethnicityOrRace,
        veteran: rowData.episode.partcipant.veteran,
        deployedCombatDuty: rowData.episode.partcipant.deployedCombatDuty,
        diagnosedPostTraumaticStressDisorder:
          rowData.episode.partcipant.diagnosedPostTraumaticStressDisorder,
        arsonist: rowData.episode.partcipant.arsonist,
        dateOfBirth: rowData.episode.partcipant.dateOfBirth,
        registration290: rowData.episode.partcipant.registration290,
        inactive: rowData.episode.partcipant.inactive,
      },
    ];  
    dispatch(participant(participantDetail));
    navigate(`/episode/details/${rowData.episode.episodeID}`);
  };

  const columnsData = [
    { field: 'actID', headerName: 'Activity Id', flex: 1 },
    { 
      field: 'episodeID', 
      headerName: 'Episode Id', 
      flex: 1,
      renderCell: (params) => {
        return (
          params.value ?
          <Button
          variant="contained"
          size="small"
          onClick={() => episodeClick(params.row)}
        >
          {params.value}
        </Button>
        : ''
        )
      }

    },
    { 
      field: 'CDC', 
      headerName: 'CDC', 
      flex: 1, 
      filterable: false,
      //renderCell: (params) => {
      //  return (
      //    params.value ?
      //    <Button
      //    variant="contained"
      //    size="small"
      //    onClick={() => cdcClick(params.row)}
      //  >
      //    {params.value}
      //  </Button>
      //  : ''
      //  )
      //}
    },
    {
      field: 'actDateCompleted',
      headerName: 'Completed',
      type: 'date',
      minWidth: 80,
      flex: 1,
    },
    {
      field: 'actDateEarly',
      headerName: 'Early',
      type: 'date',
      minWidth: 80,
      flex: 1,
      filterable: false
    },
    {
      field: 'actDateLate',
      headerName: 'Late',
      type: 'date',
      minWidth: 80,
      flex: 1,
      filterable: false
    },
    {
      field: 'activityType',
      headerName: 'Activity Type',
      renderCell: renderCellExpand,
      flex: 1,
    },
    {
      field: 'activityBy',
      headerName: 'Activity By (WestCare Employee)',
      renderCell: renderCellExpand,
      minWidth: 140,
      flex: 1,
    },
    {
      field: 'activityWith',
      headerName: 'Activity With (Contact)',
      renderCell: renderCellExpand,
      minWidth: 140,
      flex: 1,
    },
    {
      field: 'key',
      headerName: 'Activity For (Participant)',
      renderCell: renderCellExpand,
      minWidth: 140,
      flex: 1,
    },
    {
      field: 'billToOrganization',
      headerName: 'Bill To (Organization)',
      renderCell: renderCellExpand,
      flex: 1,
      filterable: false
    },
    { field: 'RgnId', headerName: 'Reg Id', flex: 1, filterable: false },
    { field: 'actIavId', headerName: 'Lav Id', flex: 1, filterable: false },
  ];

  return (
    <>
      <ContentTitle container>
        <Grid item xs={4}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <BackIcon />
            <PageHeading title='Activities' />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box style={{ alignItems: 'center' }}>
            <Typography variant='h4' align='center'>Activities</Typography>
          </Box>
        </Grid>
      </ContentTitle>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGridPro
              //autoHeight
              filterMode="server"
              onFilterModelChange={handleFilterChange}
              //getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={activityList.data}
              pageSize={activityList.pageSize}
              page={activityList.page - 1}
              rowCount={activityList.total}
              paginationMode='server'
              sortingMode='server'
              onPageSizeChange={(newPageSize) =>
                setActivityList((old) => ({ ...old, pageSize: newPageSize }))
              }
              onPageChange={(newPage) => {
                setActivityList((old) => ({ ...old, page: newPage + 1 }));
              }}
              rowsPerPageOptions={paginationSize}
              pagination
              components={{ Toolbar: QuickSearchToolbar }}
              experimentalFeatures={{ newEditingApi: true }}
              onSortModelChange={handleSortModelChange}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              loading={activityList.isLoading}
            />
          </div>
        </div>
      </div>      
    </>
  );
};
export default ActivityList;
